import { supabase } from './supabaseClient';

function getCurrentUser() {
  try {
    const raw = localStorage.getItem('currentUser');
    if (!raw) return null;
    return JSON.parse(raw);
  } catch (_) {
    return null;
  }
}

/**
 * Log a product-analytics event for the current logged-in user. Fire-and-
 * forget by design — callers should NOT await this in a way that blocks
 * the user-facing action; a failed insert here must never break the
 * actual feature (student creation, lesson save, exercise generation...).
 *
 * @param {string} eventType - e.g. 'student_created', 'lesson_created', 'exercise_generated'
 * @param {object} metadata - arbitrary JSON-serializable context for the event
 */
export function trackEvent(eventType, metadata = {}) {
  try {
    const user = getCurrentUser();
    if (!user?.id) return;
    supabase
      .from('analytics_events')
      .insert({
        event_type: eventType,
        user_id: user.id,
        role: user.role || null,
        metadata,
      })
      .then(({ error }) => {
        if (error) console.error('trackEvent insert failed:', eventType, error);
      });
  } catch (e) {
    console.error('trackEvent failed:', eventType, e);
  }
}
